import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    student: {},
    changedClasses: new Set(),
    changedCourses: new Set(),
    hasUpdate: false,
    alerts: [],
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const newState = { ...state };

    switch (type) {

        case actions.UPDATE_CLASS:
            newState.changedClasses.add(payload.classId);
            newState.hasUpdate = true;
            return newState;

        case actions.UPDATE_COURSE:
            newState.changedCourses.add(payload.courseId);
            newState.hasUpdate = true;
            return newState;

        case actions.CHANGES_SAVED:
            newState.changedClasses = new Set();
            newState.changedCourses = new Set();
            newState.hasUpdate = false;
            return newState;

        case actions.UPDATE_ALERTS:
            return { ...state, alerts: payload };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/app/app.reducer.js